module.exports = __webpack_public_path__ + "img/green3.abcb276e.jpg";